import React from 'react'
import styled from '@emotion/styled'
import { radius } from '@mobi/component-library/Foundations'
import { BetSlipButton } from './Components/BetSlipButton'
import { PendingBetsButton } from './Components/PendingBetsButton'
import type { DisplayLocation } from './types'

export const MyBetsButtons: React.FC<{
  shouldDisplayPendingBets: boolean
  isSportsRoute?: boolean
  displayLocation?: DisplayLocation
}> = ({ shouldDisplayPendingBets, isSportsRoute = false, displayLocation = 'global' }) => {
  return (
    <WrapperStyled>
      {shouldDisplayPendingBets && (
        <PendingBetsButton displayLocation={displayLocation} isSportsRoute={isSportsRoute} />
      )}

      {displayLocation !== 'betslip' && !isSportsRoute && <BetSlipButton />}
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'flex',
  alignItems: 'stretch',

  ':empty': { display: 'none' },

  '> button:only-of-type': {
    borderRadius: radius.lg,
  },

  '> button:nth-of-type(1)': {
    borderTopLeftRadius: radius.lg,
    borderBottomLeftRadius: radius.lg,
  },

  '> button:nth-of-type(2)': {
    borderTopRightRadius: radius.lg,
    borderBottomRightRadius: radius.lg,
  },
})
